import { TherapeuticGroupIssue } from '@dreryk/egabinet-group-session-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigSingleSelection,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { GroupSessionsFilterPanelSearchParam } from '../../GroupSessionsFilterPanel.types';
import { ISSUES } from '../../GroupSessionsFilterPanel.constants';

const ISSUE_TO_SEARCH_PARAM: Record<TherapeuticGroupIssue, number> = {
   NO_SCHEDULE: 0,
   NO_PRACTITIONER: 1,
   BELOW_MINIMUM_OCCUPANCY: 2,
};

export const createIssueTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenIssue: TherapeuticGroupIssue) => string) => {
   return (chosenIssue) => {
      return translate(translationKeys.issuesMap[chosenIssue]);
   };
};

export const issueCodec: FilterPanelControllerCodecConfigSingleSelection<TherapeuticGroupIssue> = {
   type: 'single-selection',
   keyGenerator: (issue) => (issue ? ISSUE_TO_SEARCH_PARAM[issue] : undefined),
   items: ISSUES,
};

export const issueDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   TherapeuticGroupIssue,
   GroupSessionsFilterPanelSearchParam.ISSUE
> = (currentIssue) => {
   return [
      {
         targetValue: null,
         label: translationKeys.issuesMap[currentIssue],
         testId: `issue-${currentIssue}`,
      },
   ];
};

export const issueDeserializer = (currentParamValue: string | null): TherapeuticGroupIssue | null => {
   return FilterPanel.paramToSingleValue(
      currentParamValue,
      'number',
      (item) => ISSUES.find((issue) => ISSUE_TO_SEARCH_PARAM[issue] === item)!
   );
};
